import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

interface HeaderProps {
  language: string;
  changeLanguage: (lng: string) => void;
}

const Header: React.FC<HeaderProps> = ({ language, changeLanguage }) => {
  const { t } = useTranslation();

  const navItems = [
    { name: t('header.home'), href: '#home' },
    { name: t('header.about'), href: '#about' },
    { name: t('header.services'), href: '#services' },
    { name: t('header.contact'), href: '#contact' },
  ];

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      const headerHeight = 80; // Adjust this value based on your header's actual height
      const elementPosition = target.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  };

  return (
    <motion.header
      className="bg-white bg-opacity-80 backdrop-filter backdrop-blur-lg fixed w-full z-10"
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ type: 'spring', stiffness: 120 }}
    >
      <div className="container mx-auto px-4 py-6 flex justify-between items-center">
        <a href="#home" onClick={(e) => handleClick(e, '#home')}>
          <motion.img
            src="/logo.svg"
            alt="eAlice Logo"
            className="h-12"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          />
        </a>
        <nav>
          <ul className="flex space-x-6">
            {navItems.map((item) => (
              <motion.li
                key={item.href}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
              >
                <a 
                  href={item.href} 
                  className="text-gray-800 hover:text-blue-600 transition-colors"
                  onClick={(e) => handleClick(e, item.href)}
                >
                  {item.name}
                </a>
              </motion.li>
            ))}
          </ul>
        </nav>
        <div className="flex space-x-2">
          <button
            onClick={() => changeLanguage('it')}
            className={`px-3 py-1 rounded ${language === 'it' ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
          >
            IT
          </button>
          <button
            onClick={() => changeLanguage('en')}
            className={`px-3 py-1 rounded ${language === 'en' ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
          >
            EN
          </button>
        </div>
      </div>
    </motion.header>
  );
}

export default Header;